export const BLOCKER_CODES = {
    ONBOARDING_NOT_FOUND: 'ONBOARDING_NOT_FOUND',
    ONBOARDING_COMPLETED: 'ONBOARDING_COMPLETED',
    ONBOARDING_BLOCKED: 'ONBOARDING_BLOCKED',
    INVALID_CONTEXT: 'INVALID_CONTEXT',
    MISSING_SAGEID_CLAIMS: 'MISSING_SAGEID_CLAIMS',
    ADMIN_CONFLICT: 'ADMIN_CONFLICT',
    ADMIN_ROLE_ERROR: 'ADMIN_ROLE_ERROR',
    ADMIN_SITE_MISMATCH: 'ADMIN_SITE_MISMATCH',
};

export const ADMIN_CREATE_FAILED = 'ADMIN_CREATE_FAILED';

export const SYNC_ERROR_CODES = {
    CREATE_FAILED: 'CREATE_FAILED',
    CREATE_TIMEOUT: 'CREATE_TIMEOUT',
    SESSION_CACHE_EMPTY: 'SESSION_CACHE_EMPTY',
    MISSING_SESSION_FIELDS: 'MISSING_SESSION_FIELDS',
};

/** @deprecated Use SYNC_ERROR_CODES.CREATE_TIMEOUT */
export const CREATE_TIMEOUT = SYNC_ERROR_CODES.CREATE_TIMEOUT;
